var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg32IconEqualizer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    "data-name": "Group 2184",
    transform: "translate(-330 -15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2307",
    "data-name": "Rectangle 2307",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(330 15)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    "data-name": "Group 2183",
    transform: "translate(330.314 14.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_volume-up_",
    "data-name": "FontAwsome (volume-up)",
    d: "M12.509,16.1a.659.659,0,0,0-.723,1.1,6.364,6.364,0,0,1,0,10.654.659.659,0,1,0,.723,1.1,7.682,7.682,0,0,0,0-12.858Zm.862,6.429a5.029,5.029,0,0,0-2.336-4.256.651.651,0,0,0-.9.2.661.661,0,0,0,.2.909,3.723,3.723,0,0,1,0,6.288.661.661,0,0,0-.2.909.652.652,0,0,0,.9.2A5.029,5.029,0,0,0,13.371,22.533ZM9.509,20.439a.654.654,0,1,0-.631,1.146,1.074,1.074,0,0,1,0,1.9.654.654,0,1,0,.631,1.146,2.381,2.381,0,0,0,0-4.188Z",
    transform: "translate(9.34 -6.632)",
    fill: "#7d6a2d",
    stroke: "#7d6a2d",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    "data-name": "Group 1838",
    transform: "translate(6.046 8.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_volume-mute_",
    "data-name": "FontAwsome (volume-mute)",
    d: "M7.509,63h0A1.63,1.63,0,0,1,9.14,64.63V75.759a1.63,1.63,0,0,1-1.631,1.626,1.607,1.607,0,0,1-1.143-.477l-2.7-2.7H.625A1.627,1.627,0,0,1-1,72.58v-4.77A1.627,1.627,0,0,1,.625,66.184H3.662l2.7-2.7A1.607,1.607,0,0,1,7.509,63ZM7.48,75.675V64.714L4.35,67.844H.66v4.7H4.35Z",
    transform: "translate(1 -63.004)",
    fill: "#7d6a2d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32IconEqualizer);
export default __webpack_public_path__ + "static/media/32-icon-equalizer.773b9771.svg";
export { ForwardRef as ReactComponent };